import Image from "@vega-assets/images/registrationIllustration.svg?react";

export const Banner = () => (
  <div className="flex w-full h-full justify-center items-center bg-[#55585a] rounded-lg overflow-hidden">
    <div className="relative w-full h-full">
      <Image className="absolute inset-0 max-w-full max-h-full m-auto" />
    </div>
  </div>
);
